<template>
  <b-card no-body class="gridlay">
    <b-card-header class="m-0 p-0 h-fixed" align="center">
      <entity-media-wrapper :entity="entity"></entity-media-wrapper>
    </b-card-header>

    <b-card-body class="pb-3 pt-3 pr-0 text-truncate footer-auto-bottom" >
      <router-link :to="{ name: 'File Details', params: { size: entity.size, checksum: entity.checksum }}"><h5 class="card-title m-0 ">{{entity.name ? entity.name : '(No Name)'}}</h5></router-link>
      <div class="d-flex justify-content-between mt-2">
        <small>{{ entity.size | bytes }} <br><span class="text-muted">{{ entity.dateLastUpdated | moment("from") }}</span></small>
        <manifest-cart-add-remove-item :entity="entity" class="pt-3"></manifest-cart-add-remove-item>
      </div>
      <!-- <h5 class="card-title m-0">{{entity.name ? entity.name : '(No Name)'}}</h5>
      <div class="d-flex justify-content-between mt-2">
        <small class="text-muted">{{ entity.dateLastUpdated | moment("from") }}</small>
        <b-button size="sm" @click="openFile" class="mr-1">Open</b-button>
      </div> -->
    </b-card-body>
  </b-card>
</template>

<script>
import ManifestCartAddRemoveItem from '../Manifest/ManifestCartAddRemoveItem.vue';

import EntityMediaWrapper from './EntityMediaWrapper.vue';

export default {
  components: {
    EntityMediaWrapper,
    ManifestCartAddRemoveItem,
  },
  props: {
    entity: {
      required: true,
    },
  },
  methods: {
    openFile() {
      const path = `/files/${this.entity.size}/${this.entity.checksum}`;
      console.log('open entity', path);
      this.$router.push(path);
    },
  },
};

</script>

<style scoped lang="scss">
.gridlay {
  float: left;
  width:  270px;
  height: 240px;
  object-fit: cover;
}
.h-fixed{
  height: 150px;
  vertical-align: middle;
}
.footer-auto-bottom {
  padding: 0.5rem !important;
}
.pr-0 {
  padding-right: 0px !important;
}
</style>
